import React, { useContext, useEffect, useState } from 'react';
import '../Questions/styles/Slider.scss';
import { FormattedMessage } from 'react-intl';
import messages from '../../locales/messages';
import PublicImage from 'src/common/components/PublicImage';
import { layoutContext } from '../RAIAssessment';

interface sliderProps {
  data: any;
}

const Slider = (sliderProps: sliderProps) => {
  const { data } = sliderProps;
  const [sliderValue, setSliderValue] = useState<number>(0);
  const { selectedItems, setSelectedItems, setSelectedOption } =
    useContext(layoutContext);
  const questionId = data.id;

  useEffect(() => {
    if (selectedItems[data.id as keyof typeof selectedItems]) {
      const { levelId } = selectedItems[data.id as keyof typeof selectedItems];
      setSliderValue(levelId);
    }
  });

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    const newValueString = `${newValue}`;
    setSliderValue(newValue);

    const level = data.levels.find((l: any) => {
      if (l.levelId == newValue) {
        return l;
      }
    });
    setSelectedItems({
      ...selectedItems,
      [questionId]: level,
    });
    setSelectedOption({
      optionId: newValueString,
      nextStep: data.nextStep,
    });
  };
  const setSliderText = (value: number) => {
    switch (value) {
      case 10:
        return <FormattedMessage {...messages.sliderLow} />;
      case 20:
        return <FormattedMessage {...messages.sliderMedium} />;
      case 30:
        return <FormattedMessage {...messages.sliderHigh} />;
      default:
        return '';
    }
  };

  const setImageSuffix = (value: number) => {
    if (value === 10) {
      return '-low';
    } else if (value === 20) {
      return '-medium';
    } else if (value === 30) {
      return '-high';
    } else {
      return '-bw';
    }
  };

  const imageSuffix = setImageSuffix(sliderValue);

  return (
    <div className="rai-assessment__slider-container">
      <PublicImage
        imgPath={`images/imageq4${imageSuffix}.svg`}
        widgetId="rai-assessment"
        alt={'test'}
        className="rai-assessment__slider-image"
      />
      <p className="rai-assessment__slider-text">
        {setSliderText(sliderValue)}
      </p>
      <input
        type="range"
        min={0}
        max={30}
        step={10} //optional
        value={sliderValue}
        onChange={(e) => handleSliderChange(e)}
        className="rai-assessment__slider-input"
      />
      <p className="rai-assessment__slider-description">
        Drag the slider to select your answer
      </p>
    </div>
  );
};

export default Slider;
